import {React, useState} from 'react';
import NavLogo from '../images/jcoyne-logo-small.png';

// Checks current state of hamburger menu, either clicked on or not
export default function Navbar() {
    const [burger, setBurger] = useState(false);
    let ToggleClass = () => {
        setBurger(!burger);
    };

    return (
        <nav>
            <div id="logo">
                <a href="/">
                    <img src={NavLogo} alt="JCoyne.dev" />
                </a>
            </div>
            <div id="navmenu">
                <div id="burger" className={burger ? "crossed" : ""} onClick={ToggleClass}>
                    <span id="firstline"></span>
                    <span id="secondline"></span>
                    <span id="thirdline"></span>
                    <ul className={burger ? "dropdown" : "hidden"}>
                        <li><a href="/about">About</a></li>
                        <li><a href="/portfolio">Portfolio</a></li>
                        <li><a href="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}